import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';
import Button from '../ui/Button';

const NAV_LINKS = [
  { path: '/', label: 'Home' },
  { path: '/plans', label: 'Plans' },
  { path: '/features', label: 'Features' },
];

export default function PublicNav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur-sm">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img src={`${process.env.PUBLIC_URL}/sightline-logo-white.png`} alt="SightLine Hosting" className="h-10 w-auto" />
          <span className="hidden text-xs font-semibold text-sky-600 sm:block">HOSTING</span>
        </Link>

        {/* Desktop nav */}
        <div className="hidden items-center gap-6 md:flex">
          {NAV_LINKS.map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition ${location.pathname === link.path ? 'text-sky-600' : 'text-slate-600 hover:text-slate-900'}`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Desktop actions */}
        <div className="hidden items-center gap-3 md:flex">
          <Link to="/login">
            <Button variant="ghost" size="sm">Log In</Button>
          </Link>
          <Link to="/plans">
            <Button size="sm">
              Get Started <ChevronRight className="h-4 w-4" />
            </Button>
          </Link>
        </div>

        {/* Mobile toggle */}
        <button onClick={() => setMobileOpen(!mobileOpen)} className="rounded-lg p-2 text-slate-600 hover:bg-slate-100 md:hidden">
          {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="border-t border-slate-200 bg-white px-6 py-4 md:hidden">
          <div className="flex flex-col gap-3">
            {NAV_LINKS.map(link => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileOpen(false)}
                className={`rounded-lg px-3 py-2 text-sm font-medium ${location.pathname === link.path ? 'bg-sky-50 text-sky-600' : 'text-slate-600'}`}
              >
                {link.label}
              </Link>
            ))}
            <hr className="border-slate-200" />
            <Link to="/login" onClick={() => setMobileOpen(false)}>
              <Button variant="secondary" className="w-full">Log In</Button>
            </Link>
            <Link to="/plans" onClick={() => setMobileOpen(false)}>
              <Button className="w-full">Get Started</Button>
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
